import React from "react";
import { withStyles } from "@material-ui/core/styles";
import createStyles from "@material-ui/core/styles/createStyles";
import { Theme } from "@material-ui/core/styles/createMuiTheme";
import AppBarNavChip, { AppBarNavChipItem } from "./AppBarNavChip";
import { appBarStyles } from "./appBarTheme";

const styles = (theme: Theme) => createStyles(appBarStyles(theme));

interface Props {
  classes: { navAfterLogo: string };
  items: AppBarNavChipItem[];
}

const AppBarNav = ({ classes, items }: Props) => (
  <nav className={classes.navAfterLogo} aria-label="Navigation principale">
    {items.map((item) => (
      <AppBarNavChip key={item.href} item={item} />
    ))}
  </nav>
);

export default withStyles(styles)(AppBarNav);
